import './UploadedFiles.scss'

import { List } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Button } from '@/components/ui/button'
import { Checkbox } from '@/components/ui/checkbox'
import { Text } from '@/components/ui/typography'
import useColorModeValue from '@/hooks/useColorModeValue'
import { ITranslatedDocs, IUploadTranslationFiles } from '@/types/translation/Translate'

import FileItem from './components/FileItem'

const UploadedFiles = ({ files, onItemClick, onSelectAll, onDelete, onTranslateClick, loadingDeleteIndex }: IUploadTranslationFiles) => {
    const { t } = useTranslation()

    const [isAllSelected, setIsAllSelected] = useState<boolean>(false)
    const [isAtLeastOneSelected, setIsAtLeastOneSelected] = useState<boolean>(false)
    const isIndeterminate = files.some((item) => item.selected) && !isAllSelected

    useEffect(() => {
        if (files.every((item) => item.selected === true)) {
            setIsAllSelected(true)
        } else if (isAllSelected) {
            setIsAllSelected(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [files])

    useEffect(() => {
        if (files.length && files.some((item) => item.selected === true)) {
            setIsAtLeastOneSelected(true)
        } else {
            setIsAtLeastOneSelected(false)
        }
    }, [files])

    const onSelectAllClicked = () => {
        setIsAllSelected(!isAllSelected)
        onSelectAll(!isAllSelected)
    }

    const generateFileList = (): React.ReactNode => {
        return files.map((file: ITranslatedDocs, index: number) => {
            return (
                <FileItem
                    key={file.name + index}
                    name={file.name}
                    index={index}
                    isSelected={isAllSelected || file.selected}
                    onItemClick={onItemClick}
                    onDelete={onDelete}
                    isDeleteDisabled={loadingDeleteIndex === index}
                    loadingDeleteIndex={loadingDeleteIndex}
                />
            )
        })
    }

    return (
        <>
            <Box w="99%" display="inline-block" overflow="auto" minH="50px">
                <Box display="flex" alignItems="center" mb="16px" mt="16px">
                    <Checkbox
                        variant="gsk"
                        className="uploadedFiles"
                        alignItems="top"
                        onCheckedChange={onSelectAllClicked}
                        checked={isIndeterminate ? 'indeterminate' : isAllSelected}
                        width="24px"
                        mt="-6px"
                        mr="12px"
                    />
                    <Text
                        fontSize="12px"
                        color={useColorModeValue('var(--chakra-colors-dark-700)', 'rgba(255, 255, 255, 0.7)')}
                        letterSpacing="0.5px"
                    >
                        {t('translate.checkbox.selectAll')}
                    </Text>
                </Box>

                <Box>
                    <List.Root variant="gigi">{generateFileList()}</List.Root>
                </Box>
            </Box>
            <Button variant="primary" ml="16px" mt="16px" h="32px" disabled={!isAtLeastOneSelected} onClick={() => onTranslateClick()}>
                <Text
                    ml="8px"
                    fontSize="12px"
                    fontFamily="GSKPrecision-Bold"
                    fontWeight="bold"
                    textTransform="uppercase"
                    letterSpacing="1.5px"
                    lineHeight="16px"
                >
                    {t('translate.buttons.translateDocuments')}
                </Text>
            </Button>
        </>
    )
}

export default UploadedFiles
